// extracted by mini-css-extract-plugin
export var colorSquare = "_sc-0";
export var danger = "_sc-5";
export var lightPink = "_sc-8";
export var neutralBlue = "_sc-7";
export var neutralYellow = "_sc-6";
export var normal = "_sc-1";
export var primary = "_sc-2";
export var primaryLight = "_sc-3";
export var solidBlack = "_sc-g";
export var solidGreen = "_sc-b";
export var solidLightBlue = "_sc-d";
export var solidNavy = "_sc-c";
export var solidOrange = "_sc-f";
export var solidPink = "_sc-e";
export var solidRed = "_sc-9";
export var solidYellow = "_sc-a";
export var success = "_sc-4";